import React, { useEffect, lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
// import IndexPage from "../website/pages/indexPage";
// import Products from "../website/pages/Products";
// import ProductDetail from "../website/pages/productDetail";
// import Faq from "../website/pages/staticPages/faq";
// import Disclaimer from "../website/pages/staticPages/disclaimer";
// import ContactUs from "../website/pages/contactUs";
// import DefaultLayout from "./defaultLayout";
// import Login from "../session.pages/login.page";
// import ForgetPassword from "../session.pages/forgotPassword";
// import ResetPasswordPage from "../session.pages/resetPassword.page";
// import OtpVerficationPage from "../session.pages/otpVerification.page";
// import Register from "../session.pages/register.page";
// import NewPassword from "../session.pages/NewPassword";
// import UserOrders from "../component/user/userOrders/UserOrders";
// import NotFound from "../session.pages/notFound.page";
// import Cart from "../website/pages/cart";
// import Profile from "../website/pages/Profile/Profile";
// import PublicRoutes from "./publicRoutes";
import { cartTotalsSuccess } from "../reducers/users/user";
import { useDispatch, useSelector } from "react-redux";
import PrivateRoute from "./privateRoute";
import { getFromLocalStorage } from "../helpers";
import UserOrderDetails from "../component/user/userOrders/UserOrderDetails";

const DefaultLayout = lazy(() => import("./defaultLayout"));
const IndexPage = lazy(() => import("../website/pages/indexPage"));
const Products = lazy(() => import("../website/pages/Products"));
const ProductDetail = lazy(() => import("../website/pages/productDetail"));
const Disclaimer = lazy(() =>
  import("../website/pages/staticPages/disclaimer")
);
const ContactUs = lazy(() => import("../website/pages/contactUs"));
const ForgetPassword = lazy(() => import("../session.pages/forgotPassword"));
const OtpVerficationPage = lazy(() =>
  import("../session.pages/otpVerification.page")
);
const NewPassword = lazy(() => import("../session.pages/NewPassword"));
const Login = lazy(() => import("../session.pages/login.page"));
const Register = lazy(() => import("../session.pages/register.page"));
const Faq = lazy(() => import("../website/pages/staticPages/faq"));
const Cart = lazy(() => import("../website/pages/cart"));
const UserOrders = lazy(() =>
  import("../component/user/userOrders/UserOrders")
);
const Profile = lazy(() => import("../website/pages/Profile/Profile"));

const App = () => {
  const { cart } = useSelector((state) => state.cart);
  const dispatch = useDispatch();
  let user = getFromLocalStorage("userType");

  useEffect(() => {
    dispatch(cartTotalsSuccess());
  }, [cart]);
  return (
    <Routes>
      <Route
        path="/*"
        element={
          <PrivateRoute>
            <DefaultLayout />
          </PrivateRoute>
        }
      />
      <Route path="/forgot-password" index element={<ForgetPassword />} />
      <Route path="/otp-verification" index element={<OtpVerficationPage />} />
      <Route path="/set-new-password" index element={<NewPassword />} />
      <Route path="/login" index element={<Login />} />
      {/* <Route path="*" element={<PublicRoutes />} /> */}
      <Route path="/" index element={<IndexPage />} />
      <Route path="/register" index element={<Register />} />
      <Route path="/products" index element={<Products />} />

      <Route path="/product/:id" index element={<ProductDetail />} />

      <Route path="/faq" index element={<Faq />} />

      <Route path="/about-us" index element={<Disclaimer />} />

      <Route path="/contact" index element={<ContactUs />} />
      <Route path="/cart" index element={<Cart />} />
      <Route
        path="/user-orders"
        element={
          <PrivateRoute>
            <UserOrders />
          </PrivateRoute>
        }
      />
      <Route
        path="/user/user-order-details/:id"
        element={
          <PrivateRoute>
            <UserOrderDetails />
          </PrivateRoute>
        }
      />
      {/* <Route path="/user-orders" index element={<UserOrders />} />  */}
      <Route path="/profile" index element={<Profile />} />
      {/* <Route path='*' index element={<NotFound />} /> */}
    </Routes>
  );
};

export default App;
